import { Injectable } from '@angular/core';

@Injectable()
export class TrainingZonesService {

  constructor() { }

  mmpZones() {
    return [
      {
        from: 0,
        to: .35,
        text: 'Recovery'
      }, {
        from: .35,
        to: .45,
        text: 'Zone 1'
      }, {
        from: .45,
        to: .55,
        text: 'Zone 2'
      }, {
        from: .55,
        to: .65,
        text: 'Zone 3'
      }, {
        from: .65,
        to: .75,
        text: 'Zone 4'
      }, {
        from: .75,
        to: .85,
        text: 'Zone 5'
      }, {
        from: .85,
        to: 1,
        text: 'Maximal'
      }, {
        from: 1,
        to: Infinity,
        text: 'Supra Maximal'
      }
    ];
  }

  mhrZones(){

    return [
      {
        from: 0,
        to: .6,
        text: 'Recovery'
      }, {
        from: .6,
        to: .65,
        text: 'Zone 1'
      }, {
        from: .65,
        to: .75,
        text: 'Zone 2'
      }, {
        from: .75,
        to: .82,
        text: 'Zone 3'
      }, {
        from: .82,
        to: .89,
        text: 'Zone 4'
      }, {
        from: .89,
        to: .94,
        text: 'Zone 5'
      }, {
        from: .94,
        to: Infinity,
        text: 'Maximal'
      }
    ];
  }

  ftpZones(){

    return [{
        from: 0,
        to: .55,
        text: 'Active Recovery'
      }, {
        from: .55,
        to: .75,
        text: 'Endurance'
      }, {
        from: .75,
        to: .9,
        text: 'Tempo'
      }, {
        from: .9,
        to: 1.05,
        text: 'Lactate Threshold'
      }, {
        from: 1.05,
        to: 1.2,
        text: 'VO2max'
      }, {
        from: 1.2,
        to: Infinity,
        text: 'Anaerobic Capacity'
      }
    ];
  }

  thrZones(){

    return [{
        from: 0,
        to: .68,
        text: 'Active Recovery'
      }, {
        from: .68,
        to: .83,
        text: 'Endurance'
      }, {
        from: .83,
        to: .94,
        text: 'Tempo'
      }, {
        from: .94,
        to: 1.05,
        text: 'Lactate Threshold'
      }, {
        from: 1.05,
        to: Infinity,
        text: 'VO2max'
      }
    ];
  }

}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/training-zones.service.ts